export default __webpack_public_path__ + "media/images/features/ja/appeal_left-2ce1077c6a714aa6bab1313f66a4d57b.png";